import {input as collapse} from "./collapse";
import {input as expand} from "./expand";
import {input as join} from "./join";
import {input as search} from "./search";

export const commands = {
	collapse: collapse,
	expand: expand,
	join: join,
	search: search,
};
